/**
 * Featured brokerage configuration.
 *
 * Simply Approved Mortgages is a licensed mortgage BROKERAGE, not a lender.
 * They connect borrowers with HUD-approved HECM lenders.
 */
export const LENDER = {
  name: "Simply Approved Mortgages",
  shortName: "Simply Approved Mortgages",
  tagline: "Reverse mortgage brokerage for homeowners 62+",
  businessType: "Mortgage brokerage",
  nmlsNumber: "2620881",
  nmls: "Simply Approved Mortgages NMLS #2620881",
  nmlsShort: "NMLS #2620881",
  website: "https://dscrloanmarket.com",
  licensedStates: "Licensed in Florida (FL) and Colorado (CO). Confirm availability when you request your free estimate.",
  hours: "Mon – Fri, 8 AM – 7 PM ET · Sat, 9 AM – 2 PM ET",
  disclosure:
    "Simply Approved Mortgages is a licensed mortgage brokerage. Reverse mortgage loans are funded by third-party HUD-approved HECM lenders.",
} as const;

export const SITE = {
  name: "Simply Approved Mortgages",
  legalName: "Simply Approved Mortgages",
  description:
    "Independent, plain-English reverse mortgage education, calculators, and eligibility tools — with Simply Approved Mortgages as your featured reverse mortgage broker.",
} as const;
